<app-view-title [isSafeSignal]="!late" [isDangerSignal]="late" Title="{{ 'Intellitrailer.Rental.InFlight.Headline' | translate : 'Active rent' }}"></app-view-title>
<view-content [centered]="true">
  <app-card>
    <app-rental-box *ngIf="booking" [booking]="booking" [hasLock]="hasLock" [allowUnmanned]="allowUnmanned" (rentalAction)="recieveRentalAction($event)"></app-rental-box>
  </app-card>
</view-content>
